import React from "react";
import { OptimizedGantt, WorkLoadsCalendar } from "@planzone/dto";
import { Props } from "./types";

const ProjectElementsCounter = ({
  ganttByProject,
  workLoad,
  projectUuid,
  setProjectElementsNbr,
  toggledLists,
}: Props) => {
  React.useEffect(() => {
    if (!setProjectElementsNbr) return;

    let count = 0;

    const isElementVisible = (element: OptimizedGantt[number]): boolean => {
      if (!element.parentUuid || element.depth === 0) {
        return true;
      }
      const parentKey = `${workLoad.uuid}:${element.parentUuid}`;
      if (toggledLists[parentKey] === false) {
        return false;
      }
      const parent = ganttByProject.find(
        (el) => el.uuid === element.parentUuid,
      );
      if (parent) {
        return isElementVisible(parent);
      }
      return true;
    };

    ganttByProject.forEach((element) => {
      if (isElementVisible(element)) {
        count++;
      }
    });

    setProjectElementsNbr(`${workLoad.uuid}:${projectUuid}`, count);
  }, [
    ganttByProject,
    workLoad.uuid,
    projectUuid,
    toggledLists,
    setProjectElementsNbr,
  ]);

  return null;
};

export { ProjectElementsCounter };
